export const SET_USER_INFO = 'SET_USER_INFO';

export const START_LOADING = 'START_LOADING';
export const FINISH_LOADING = 'FINISH_LOADING';
export const SET_MODAL_STATUS = 'SET_MODAL_STATUS';
export const SET_MODAL_NAME = 'SET_MODAL_NAME';

export const SET_PROBLEMSET = 'SET_PROBLEMSET';

export const SET_QUESTION_BY_PROBLEMID = 'SET_QUESTION_BY_PROBLEMID';
export const REMOVE_QUESTION = 'REMOVE_QUESTION';

export const SET_MY_CWHUNT = 'SET_MY_CWHUNT';
export const CLEAR_MY_CWHUNT = 'CLEAR_MY_CWHUNT';

export const SET_TEACHER_LIST = 'SET_TEACHER_LIST';
export const SET_STUDENT_LIST = 'SET_STUDENT_LIST';

export const SET_COMMITMENT_STATUS = 'SET_COMMITMENT_STATUS';
export const SET_NOTICEBOARD_STATUS = 'SET_NOTICEBOARD_STATUS';

export const SET_ONLINE_DATA = 'SET_ONLINE_DATA';
